import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const namespaced = true;

const trainingAttendanceModule = {
  state,
  mutations,
  actions,
  getters,
  namespaced,
};

export default trainingAttendanceModule;
